/**
 * ColoresModulos.js
 * Mapa centralizado de semCode → color para el BuscadorGlobal.
 *
 * Los valores fueron verificados contra la BD (PaletaColores / ColorIconosMenuLateral).
 * Keys en mayúsculas para coincidir con los valores reales de semCode del stored procedure.
 *
 * Módulos con PaletaColores existente en el Frontend:
 *   ANALYZE, AUTOMIGRADOR, CAJAS, CORPORATIVO, INTEGRA, PARAM, SECUR, UTILIDADES
 *
 * Módulos de BD sin PaletaColores en Frontend:
 *   AC_C, CONTRATOS, CXC, CTRASIS, ENCUESTA, ESTUDIANTES,
 *   INTEGRACONTA, KRUD, NINGRESO, NOCODE, PROFESORES, VELO, '0' (PROCESOS)
 */

// ── Mapa semCode → hex color ──────────────────────────────────────────────────
export const COLORES_MODULOS = {
  // Módulos con PaletaColores existente
  'ANALYZE': '#117CAF',        // Reporteador Analyze
  'AUTOMIGRADOR': '#117CAF',   // Automigrador
  'CAJAS': '#00C089',          // Cajas
  'CORPORATIVO': '#00C089',    // Cuentas Corporativas
  'INTEGRA': '#117CAF',        // Integraciones
  'PARAM': '#117CAF',         // Parametros
  'SECUR': '#5C6376',          // Seguridad
  'UTILIDADES': '#117CAF',    // Utilidades

  // Módulos de BD sin PaletaColores en Frontend
  'AC_C': '#17B6CA',           // Class
  'CONTRATOS': '#117CAF',     // Contratos
  'CXC': '#00C089',            // Cuentas por Cobrar
  'CTRASIS': '#117CAF',        // Registro Asistencia
  'ENCUESTA': '#117CAF',      // Encuestas
  'ESTUDIANTES': '#17B6CA',   // Portal Estudiantes (turquesa)
  'INTEGRACONTA': '#117CAF',   // Integración Contable
  'KRUD': '#117CAF',          // Krud
  'NINGRESO': '#17B6CA',      // Portal Nuevo Ingreso (turquesa)
  'NOCODE': '#117CAF',        // API No Code
  'PROFESORES': '#17B6CA',    // Portal Profesores (turquesa)
  'VELO': '#117CAF',          // Velo
  '0': '#117CAF',             // PROCESOS (clave numérica como string)
};

// ── Color de fallback ─────────────────────────────────────────────────────────
// Coincide con el turquoise #1ABC9C que ya usaba el frontend por defecto.
// Mantiene backwards-compatible la experiencia visual para módulos desconocidos.
export const COLOR_FALLBACK = '#17B6CA';

// ── Helper para obtener color ─────────────────────────────────────────────────
/**
 * Obtiene el color hexadecimal correspondiente a un semCode.
 *
 * @param {string|number|null|undefined} semCode - Código del módulo (case-sensitive, debe ser mayúsculas)
 * @returns {string} Color hex del módulo, o COLOR_FALLBACK si no se encuentra
 *
 * @example
 * getColorModulo('CAJAS')      // → '#00C089'
 * getColorModulo('SECUR')     // → '#5C6376'
 * getColorModulo('AC_C')      // → '#17B6CA'
 * getColorModulo('0')         // → '#117CAF' (PROCESOS)
 * getColorModulo(null)        // → '#17B6CA' (fallback)
 * getColorModulo('UNKNOWN')   // → '#17B6CA' (fallback)
 */
export const getColorModulo = (semCode) => {
  // Handle null, undefined, empty string
  if (semCode === null || semCode === undefined || semCode === '') {
    return COLOR_FALLBACK;
  }
  // Handle numeric keys (like '0' for PROCESOS)
  const key = String(semCode);
  return COLORES_MODULOS[key] ?? COLOR_FALLBACK;
};
